/**
 * Публичный конфиг SPA (CAPTCHA site key).
 */

import { apiRequest } from "./http";

export type PublicConfig = {
  captchaSiteKey: string;
};

export async function loadPublicConfig(): Promise<PublicConfig> {
  return apiRequest<PublicConfig>("/public-config");
}
